// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/assetstores.styl
// module id = 368
// module chunks = 0